export default __webpack_public_path__ + "static/media/lunchHealthgenom.408baf7e.svg";